module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/190-uzbekistn-6b7565b9b5e0dec859637e70a083e771.svg";